// const defaults = {
//   primary: "#2196f3",
//   secondary: "#f50057",
// };

const defaults = {
  primary: "#122C44",
  secondary: "#de5246",
};

export default {
  fromString(value) {
    if (!value || !value.includes("-")) {
      return { ...defaults };
    }

    const [primary, secondary] = value.split("-");

    return {
      primary,
      secondary,
    };
  },

  toString(value) {
    if (value && value.primary && value.secondary) {
      return `${value.primary}-${value.secondary}`;
    }

    return `${defaults.primary}-${defaults.secondary}`;
  },
};
